<template>
  <div>
    <div class="main-left">
      <Row>
        <Col span="8">
          <Menu @on-select="changeResumeByYear" accordion>
            <Submenu name="study">
              <template slot="title">
                  {{$t('i.resume.studyTrain')}}
              </template>
              <MenuItem :name="`study-${getName(particularYear)}`" v-for="(particularYear,index) in resumeYears" :key="`study${index}`">{{particularYear}}</MenuItem>
            </Submenu>
            <Submenu name="exam">
              <template slot="title">
                  {{$t('i.resume.examinationRecords')}}
              </template>
              <MenuItem :name="getName(particularYear)" v-for="(particularYear,index) in resumeYears" :key="index">{{particularYear}}</MenuItem>
            </Submenu>
          </Menu>
        </Col>
      </Row>
    </div>
    <div v-show="time">
      <!-- 研修履历 -->
      <div class="main-right" v-show="!tableTab">
        <search-form>
          <search-form-item :label="`${$t('i.resumeRecord.user')}：`">
            <Input v-model="studyQuery.empname" placeholder="请输入学员名称"/>
          </search-form-item>
          <search-form-item :label="`${$t('i.studyColumn.studyName')}：`">
            <Input v-model="studyQuery.className" placeholder="请输入研修名称"/>
          </search-form-item>
        <!--  <search-form-item :label="`${$t('i.studyColumn.isMe')}：`">
            <Select v-model="studyQuery.isMe">
              <Option v-for="item in isMeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </search-form-item>-->
          <search-form-item>
            <Button type="primary" icon="ios-search" @click="searchStudy" class="searchBtn2" >{{ $t('i.resumeRecord.search') }}</Button>
          </search-form-item>
        </search-form>
        <Table stripe :loading="studyLoading"  height="500" :columns="studyColumn" :data="studyData"></Table>
        <div class="control">
          <div class="control-play">
            <Page :total="totalRow" :page-size="pageSize"  style="text-align:center;margin-top: 15px;margin-bottom: 15px;" @on-change="pageNumberChange"  @on-page-size-change='pageSizeChange'  show-sizer show-total />
          </div>
        </div>
      </div>
      <!-- 听课记录及考试记录 -->
     <div class="main-right" v-show="tableTab">

      <search-form>
        <search-form-item :label="`${$t('i.resumeRecord.user')}：`">
          <Input v-model="empname" placeholder="请输入学员名称"/>
        </search-form-item>
        <search-form-item :label="`${$t('i.resumeRecord.title')}：`">
          <Input v-model="title" placeholder="请输入教材名"/>
        </search-form-item>
        <search-form-item>
          <Button type="primary" icon="ios-search" @click="searchTest" class="searchBtn2" >{{ $t('i.resumeRecord.search') }}</Button>
          <!-- <Button type="primary" icon="ios-share-alt" @click="leadingOut" class="searchBtn2" style="margin-right: 5px">{{ $t('i.resumeRecord.derive') }}</Button> -->
        </search-form-item>
      </search-form>

      <Table stripe :loading="resumeLoading"  height="500" :columns="resumeColumn" :data="resumeList"></Table>
      <div class="control">
        <div class="control-play">
          <Page :total="totalRow" :page-size="pageSize"  style="text-align:center;margin-top: 15px;margin-bottom: 15px;" @on-change="pageNumberChange"  @on-page-size-change='pageSizeChange'  show-sizer show-total />
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  import RequestUtil from '../../../utils/RequestUtil';
  import Constants from '../../../common/Constants';

  export default {
    name: "listOfResume",
    data(){
      let userInfo = localStorage.getItem("userInfo");
      if(userInfo){
        userInfo = JSON.parse(userInfo);
      }
      return{
        userInfo: userInfo,
        isMeList: [
          {
              value: '1',
              label: this.$t('i.studyModelData.yes'),
          },
          {
            value: '0',
            label: this.$t('i.studyModelData.no'),
          }
        ],
        model: '',
        tableTab: true,
        pageSize : this.Constants.pageSize , //每页显示10条数据
        pageNumber : this.Constants.pageCurrent, //当前页码
        totalRow : 20, //总记录数
        totalPage : 100,//总页数
        title:'',
        empname:'',
        pageSize : this.Constants.pageSize , //每页显示10条数据
        pageNumber : this.Constants.pageCurrent, //当前页码
        totalRow : 20, //总记录数
        totalPage : 100,//总页数
        studyQuery: {
          className : '',
          isMe: '',
          empname: ''
        },
        studyLoading: true,
        studyData: [],
        studyColumn: [
          {
            title: this.$t('i.studyColumn.name'),
            key: `${localStorage.getItem('defaultLangValue') == 'zh_CN' ? 'empname' : 'empnamej' }`
          },
          {
            title: this.$t('i.studyColumn.studyName'),
            key: `${localStorage.getItem('defaultLangValue') == 'zh_CN' ? 'class_name' : 'class_namej' }`
          },
          {
            title: this.$t('i.studyColumn.endDate'),
            key: 'time'
          },
          {
            title: this.$t('i.studyColumn.depName'),
            key: `${localStorage.getItem('defaultLangValue') == 'zh_CN' ? 'org_name' : 'org_namej' }`
          },
          {
            title: this.$t('i.studyColumn.studyStatus'),
            key: 'type',
            render: (h, params) => {
                return h('div', [
                    h('Icon', {
                        props: {
                            type: 'person'
                        }
                    }),
                    h('span', params.row.is_finish == '1' ? this.$t('i.isPass.yes') : this.$t('i.isPass.no'))
                ]);
            }
          },
        ],
        resumeColumn:[
          {
            type: 'index',
            title: this.$t('i.resumeRecord.number'),
            width: 60,
            align: 'center'
          },
          {
            title: this.$t('i.resumeRecord.user'),
            width: 90,
            key: 'empname'
          },
          {
            title: this.$t('i.resumeRecord.title'),
            width: 120,
            key: 'title'
          },
          {
            title: this.$t('i.resumeRecord.score'),
            width: 80,
            key: 'personal_score'
          },
          {
            title: this.$t('i.resumeRecord.answerTimes'),
            width: 90,
            key: 'answer_times'
          },
          {
            title: this.$t('i.resumeRecord.theEndTime'),
            // ellipsis: true,
            // tooltip: true,
            width: 150,
            key: 'theEndTime',
            render: (h, params) => {
                return h('div', [
                    h('Icon', {
                        props: {
                            type: 'person'
                        }
                    }),
                    h('span', params.row.last_modify_time ? params.row.last_modify_time : params.row.create_time)
                ]);
            }
          },
          {
            title: this.$t('i.resumeRecord.status'),
            key: 'status',
            render: (h, params) => {
                return h('div', [
                    h('Icon', {
                        props: {
                            type: 'person'
                        }
                    }),
                    h('span', params.row.status == '1' ? this.$t('i.resumeStatus.yes') :  this.$t('i.resumeStatus.no'))
                ]);
            }
          },
          {
            title: this.$t('i.resumeRecord.isPass'),
            width: 90,
            key: 'isPass',
            render: (h, params) => {
                return h('div', [
                    h('Icon', {
                        props: {
                            type: 'person'
                        }
                    }),
                    h('span', params.row.is_pass == '1' ? this.$t('i.isPass.yes') :  this.$t('i.isPass.no'))
                ]);
            }
          },
        ],
        resumeLoading: true,
        recordEducationList:[], //学习记录列表
        resumeList:[],
        resumeYears:[],
        time: '',
        defaultMenu: '2021',
        orgName:'',
        personName:'',
        finish:'',
        courseName:'',
        company:'',
      }
    },
    created() {
      this.getResumeList()
      // this.defaultMenu = `study-${new Date().getFullYear()}`
    },
    methods:{
      async onClickstudy(){
        this.resumeList = [];
        this.tableTab = false;
        this.pageSize = this.Constants.pageSize//每页显示10条数据
        this.pageNumber = this.Constants.pageCurrent//当前页码
        this.totalRow = 0 //总记录数
        this.totalPage = 0//总页数
        //this.getStudyList();
      },

      async getResumeList(){
        this.resumeLoading = true
        if(!this.tableTab){
          this.tableTab = true;
          this.pageSize = this.Constants.pageSize  //每页显示10条数据
          this.pageNumber = this.Constants.pageCurrent, //当前页码
          this.totalRow = 0//总记录数
          this.totalPage = 0//总页数
        }
        let data ={
          empname:this.empname,
          title:this.title
        }
        const json = await RequestUtil.request("/front/resume/getResumeList?pageCurrent=" + this.pageNumber + "&pageSize="
          + this.pageSize +"&time="+this.time,data);
        if(json){
          if(json.statusCode == Constants.statusCode.ok){
            this.resumeList = json.datas.list;
            this.itemsNews = json.datas.list;
            this.pageSize = json.datas.pageSize;
            this.pageNumber = json.datas.pageNumber;
            this.totalRow = json.datas.totalRow;
            this.totalPage = json.datas.totalPage;
            this.resumeYears = json.datas.year;
            this.resumeLoading = false
          }
        }
      },

      async getStudyList(){
        this.studyLoading = true
        const domain = localStorage.getItem('domain');

        // let data = {...this.studyQuery, ...{ ssly: domain}, ...{ year: this.time}};
        let data = {...this.studyQuery, ...{ year: this.time}};
        const json = await RequestUtil.request("/front/train/list?pageCurrent=" + this.pageNumber + "&pageSize="
            + this.pageSize,data);
        if(json){
          if(json.statusCode == Constants.statusCode.ok){
            this.studyData = json.datas.list;
            this.pageSize = json.datas.pageSize;
            this.pageNumber = json.datas.pageNumber;
            this.totalRow = json.datas.totalRow;
            this.totalPage = json.datas.totalPage;
            this.studyLoading = false
          }
        }
      },

      searchTest(){
        this.pageNumber = this.Constants.pageCurrent
        this.getResumeList()
      },

      searchStudy(){
        this.pageNumber = this.Constants.pageCurrent
        this.getStudyList()
      },

      changeResumeByYear:async function(name){
        // this.time = name;
        this.tableTab = false
        const arr = String(name).split('-');
        if (arr.length < 2) {
          this.time = name
          this.getResumeList()
        } else {
          this.time = arr[1]
          this.getStudyList()
        }
      },
      pageNumberChange(value){
        this.pageNumber = value;
        if(this.tableTab){
          this.getResumeList()
        }else{
         this.getStudyList();
        }
      },
      pageSizeChange(value){
        this.pageSize = value;
        if(this.tableTab){
          this.getResumeList()
        }else{
         this.getStudyList();
        }
      },
      getName(index){
        const name = index;
        return name;
      },
      leadingOut(){ //导出事件
        let defaultLangValue = localStorage.getItem("defaultLangValue");
        if(!defaultLangValue){
          defaultLangValue = "zh_CN";
        }
        window.location = this.Constants.serverURL +'/front/resume/exportStudyList?curJsSessionId='+
        localStorage.getItem("curJsSessionId") + '&orgName=' + encodeURI(this.orgName) + '&personName=' + encodeURI(this.personName)
        +'&finish='+this.finish+'&courseName=' + encodeURI(this.courseName) + '&company=' + this.company + '&language=' + defaultLangValue;
      }
    },
  // async activated(){
  //   this.getResumeList();
  // }

  }
</script>

<style scoped>
  /deep/ .ivu-menu-light{
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    border-top: 1px solid #ccc
  }
  .main-left{
    width: 260px;
    height: 300px;
    float: left;
  }
  .content-left-li{
    width: 240px;
    height: 43px;
    margin-bottom: 2px;
    list-style: none;
    line-height: 43px;
    cursor:pointer;
    padding-left: 15px;
  }
  /* .ivu-menu-submenu{
     background-color: #efefef;
     margin-bottom: 2px;
   }
  .ivu-menu-item{
    background-color: #efefef;
    margin-bottom: 2px;
  } */
  .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu),
  .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after
  {
    background-color: #f0faff;
    color: #000;
  }

  /*主体右边部分*/
  .main-right{
    width: 767px;
    height: auto;
    min-height: 530px;
    border: 1px solid #ccc;
    margin-left: 30px;
    float: left;
    border-radius: 15px;
  }
  .searchBox{
    width: 767px;
    height: 35px;
    margin: 10px 0;
    text-align: right;
    padding: 0 16px;
  }
  .searchBox span{
    line-height: 35px;
    float: right;
  }
  .screenInput2Text{
    float: left!important;
  }
  .screenInput{
    width: 150px;
    margin-right: 40px;
    float: right;
  }
  .screenInput2{
    width: 150px;
    margin-right: 40px;
    float: left;
  }
  .searchBtn{
    float: right;
    margin-right: 40px;
  }
  .searchBtn2{
    /* float: left; */
    /* float: right; */
    margin-left: 18px;
  }
  .main-tb{
    width: 700px;
    height: auto;
    margin: 25px auto 0 auto;
    text-align: center;
  }
  .trone{
    font-weight: 700;
    border-bottom: 1px solid #000;
    padding-bottom: 10px;
  }
  .common{
    color: #5c5c5c;
    padding-top: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #c7c7c7;
  }
</style>



// WEBPACK FOOTER //
// src/pages/resume/components/listOfResume.vue